export default __webpack_public_path__ + "static/media/ethereum-icon.480e2277.svg";